import dayjs from "dayjs";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import swal from 'sweetalert';
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import Modal from "../../elements/Modal";
import { Button } from "../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import restoreLedgerModalCss from "../../css/restoreLedgerModal.module.css";
import { restoreLedger } from '../../../Bookclosure/Services/ApiHandler';
import { getBCTbRows, getDeletedLedgersRows } from '../../../redux/actions/BookClosure/actionBookClosure';



const RestoreLedgerModal = ({
  handleClose,
  setRestoreLedgerModal,
  deletedLedgers,
}) => {

    const dispatch = useDispatch();
    const { bookClosureTbId } = useParams();
    
    const [restoreLedgerIds, setRestoreLedgerIds] = useState([])

    const handleToggleLedger = (ledgerId) => {
        setRestoreLedgerIds((prev) =>
            prev.includes(ledgerId)
            ? prev.filter((id) => id !== ledgerId)
            : [...prev, ledgerId]
        );
    };

    const handleToggleAll = (allIds) => {
        if (restoreLedgerIds.length === allIds.length) {
            setRestoreLedgerIds([]);
        } else {
            setRestoreLedgerIds(allIds);
        }
    };

    const RestoreLedgers = (ledgerIDs) => {
        restoreLedger(bookClosureTbId, {
            ledgerIDs
        }).then(response => {
            swal("Success", response?.data?.message || "Ledgers restored", "success");
            dispatch(getDeletedLedgersRows(bookClosureTbId));
            dispatch(getBCTbRows(bookClosureTbId));
            handleClose();
            setRestoreLedgerModal(false);
        }).catch(error => {
            swal("Error", error?.response?.data?.error || "Deleted Ledger Failed", "error");
        })
    }

    return (
        <Modal
            title="Restore Deleted Items"
            bodycss={commoncss.unsetPadding}
            width="60%"
            minHeight="300px"
            headerActions={
                <CloseIcon
                onClick={() => {
                    handleClose();
                    setRestoreLedgerModal(false);
                }}
                className="clickable"
                />
            }

            footerActions={
                <>
                    <Button
                        btnColor={buttoncss.secondary}
                        onClick={() => {
                            handleClose();
                            setRestoreLedgerModal(false);
                        }}
                        label="Cancel"
                    />

                    <div style={{ display:"flex", alignItems:"center", gap:"20px" }}>
                        {restoreLedgerIds.length > 0 && (
                            <span className={restoreLedgerModalCss.importSelectedText}>
                                ({restoreLedgerIds.length}) selected
                            </span>
                        )}
                        <Button
                            btnColor={buttoncss.primary}
                            label="Restore Selected Items"
                            onClick={() => 
                                RestoreLedgers(restoreLedgerIds)
                            }
                            disabled={restoreLedgerIds.length === 0}
                        />
                    </div>
                </>
            }
        >
            <div>
                <table className={restoreLedgerModalCss.restoreTable}>
                    <thead>
                        <tr>
                            <th className={restoreLedgerModalCss.checkboxTd}>
                                <input
                                    type="checkbox"
                                    className={restoreLedgerModalCss.customCheckbox}
                                    checked={
                                        deletedLedgers?.length > 0 &&
                                        restoreLedgerIds.length === deletedLedgers.length
                                    }
                                    onChange={() =>
                                        handleToggleAll(
                                            deletedLedgers
                                            .map((ledger) => ledger._id)
                                        )
                                    }
                                />
                            </th>
                            <th>Ledger Code</th>
                            <th>Ledger Name</th>
                            <th>Period Ending Balance</th>
                            <th>Period Begining Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(deletedLedgers.length > 0) ? (
                            deletedLedgers
                            .map((ledger, index) => (
                            <React.Fragment key={index}>
                                <tr key={index}>
                                    <td className={restoreLedgerModalCss.checkboxTd}>
                                        <input
                                            type="checkbox"
                                            className={restoreLedgerModalCss.customCheckbox}
                                            checked={restoreLedgerIds.includes(ledger._id)}
                                            onChange={() => handleToggleLedger(ledger._id)}
                                        />
                                    </td>
                                    <td>{ledger?.ledgerCode}</td>
                                    <td>{ledger?.ledgerName}</td>
                                    <td>{ledger?.periodEndingBalance}</td>
                                    <td>{ledger?.periodBeginingBalance}</td>
                                </tr>
                            </React.Fragment>
                            ))
                        )
                        :(
                            <tr>
                                <td
                                colSpan={6}
                                className="text-secondary text-center font-size-16 custom-font-600 font-inter"
                                >
                                {" "}
                                No deleted ledgers.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Modal>
    );
};

export default RestoreLedgerModal;
